<div class="order-summary-preview">
  <h3>Order Summary</h3>
  <div class="product-list">
    <div class="product-item">
      <div class="product-item__left">
        <div class="product-item__image skeleton"></div>
        <div class="product-item__details">
          <div class="skeleton" style="width: 175px; height: 15px"></div>
          <div class="skeleton" style="width: 105px; height: 15px"></div>
        </div>
      </div>
      <div class="product-item__right">
        <div class="product-item__price skeleton" style="width: 70px; height: 15px"></div>
      </div>
    </div>
  </div>
  <div class="coupon-input">
    <div class="coupon-input__outer">
      <div class="skeleton" style="width: 100px; height: 15px"></div>
    </div>
    <div class="skeleton" style="width: 100px"></div>
  </div>
  <div class="price-elemenet">
    <p>
      <span>Subtotal</span>
    </p>
    <p>{{ orderSubtotal() | currency: currencySymbol : 'symbol' }}</p>
  </div>
  <div class="price-elemenet">
    <p>Shipping</p>
    <p>{{ orderShipping() | currency: currencySymbol : 'symbol' }}</p>
  </div>
  <div class="price-elemenet__total">
    <p>Total</p>
    <p>{{ orderTotal() | currency: currencySymbol : 'symbol' }}</p>
  </div>
  <button class="checkout-button"></button>
</div>
